import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { apiFetch } from '../lib/api.js';
import '../styles/AdminFreeCustomers.css';

export default function AdminFreeCustomers() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user?.email === 'dev@musicbase.io') {
      fetchCustomers();
    } else if (user) {
      // Redirect back to where the user came from, or to profile if no previous page
      const from = location.state?.from?.pathname || '/profile';
      navigate(from, { replace: true });
    }
  }, [user, navigate, location]);

  const fetchCustomers = async () => {
    try {
      const data = await apiFetch('/api/admin/free-customers');
      console.log("Received data:", data);
      // Ensure we always have an array
      const customersArray = Array.isArray(data) ? data : [];
      setCustomers(customersArray);
    } catch (err) {
      console.error("Error fetching customers:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="admin-free-customers">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading free customers...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-free-customers">
        <div className="error-container">
          <svg className="error-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
          </svg>
          <h3 className="error-title">Access Denied</h3>
          <p className="error-message">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-free-customers">
      <div className="admin-header">
        <h1 className="admin-title">Free Customers</h1>
      </div>

      <div className="admin-stats">
        <div className="stat-card">
          <div className="stat-number">{customers.length}</div>
          <div className="stat-label">Total Free Customers</div>
        </div>
      </div>

      {customers.length === 0 ? (
        <div className="empty-state">
          <svg className="empty-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
          </svg>
          <h3 className="empty-title">No Free Customers</h3>
          <p className="empty-description">All users currently have active subscriptions.</p>
        </div>
      ) : (
        <div className="customers-table">
          <table>
            <thead>
              <tr>
                <th>Customer ID</th>
                <th>Email Address</th>
                <th>Registration Date</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((customer) => (
                <tr key={customer.id}>
                  <td>{customer.id}</td>
                  <td>
                    <span className="customer-email">{customer.email}</span>
                  </td>
                  <td>
                    <span className="customer-date">
                      {new Date(customer.signed_up_at).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}